/** "9 s", "5 min", "1 h 4 min". */
export function duration(ms: number) {
  if (ms < 1000) return "< 1 s";
  const seconds = Math.round(ms / 1000);
  if (seconds < 60) return `${seconds} s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
}
/** "10:45 AM" today, "Yesterday, 5:03 PM", else "Oct 10, 2:39 PM". */
export function when(value: string, now = new Date()) {
  const date = new Date(value);
  const time = date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  const day = (offset: number) => { const d = new Date(now); d.setDate(d.getDate() - offset); return d.toDateString(); };
  if (date.toDateString() === day(0)) return time;
  if (date.toDateString() === day(1)) return `Yesterday, ${time}`;
  return date.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}
/** The day header of a run list: Today, Yesterday, or the date. */
export function dayLabel(value: string, now = new Date()) {
  const date = new Date(value);
  const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1);
  if (date.toDateString() === now.toDateString()) return "Today";
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
  return date.toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric" });
}
/** For a sentence: "today at 10:45 AM", "yesterday at 5:03 PM", else "on Oct 10, 2:39 PM". */
export function at(value: string, now = new Date()) {
  const label = when(value, now);
  if (!label.includes(",") && !label.startsWith("Yesterday")) return `today at ${label}`;
  if (label.startsWith("Yesterday, ")) return `yesterday at ${label.slice("Yesterday, ".length)}`;
  return `on ${label}`;
}
